<div class="flex h-full grow flex-col">
  @if (!isLoading) {
    <!-- Show error when isError is true -->
    @if (isError) {
      <div class="p-4 text-center">
        <div class="text-base font-semibold text-gray-600">
          {{ title }}
        </div>
      </div>
      <ag1-bettabase-error
        class="flex grow items-center justify-center p-6"
        [errorName]="errorName"
        [errorMessage]="errorMessage"
      />
    } @else {
      <div class="relative h-96 w-full">
        <div class="flex items-start justify-between">
          <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="chartOptions"
            [callbackFunction]="chartCallback"
            class="h-96 w-full"
          />
        </div>
      </div>
    }
    <!-- Chart Content (if no error) -->
  } @else {
    <div class="grid h-full w-full grow place-items-center gap-2 p-5">
      <ag1-loader />
    </div>
  }
</div>

<!-- Loading State -->
